import { createRequest, RequestConfig } from 'app/common/api';

const config: RequestConfig = {
  method: 'get',
  url: '/ws/api/get_train_types',
};

export const getTrainTypesRequest = () =>
  createRequest({
    url: config.url,
    method: config.method,
  });
